module.exports = __webpack_public_path__ + "img/sampleGraph4.9361c513.png";